import axios from 'axios'
import Vue from 'vue'
import store from "../vuex/store"
import router from "../router/index"



//axios 的默认配置修改
axios.defaults.baseURL = DOCLINKAPI;
axios.defaults.paramsSerializer =  function (params) {
  return Qs.stringify(params,{arrayFormat:'brackets'})
}
//请求拦截
axios.interceptors.request.use(function (config) {
  return config;
},function (error) {
  return Promise.reject(error);
})
//返回状态的拦截
axios.interceptors.response.use(function (response) {
  return response;
},function (error) {
  return Promise.reject(error);
})
//封装get
export function gAJAX(url,params,type) {
  return new Promise((resolve,reject)=>{
    axios.get(url,params,type)
      .then(response=>{
        // store.commit('UPDATE_LOADING',false);
        if(response.data.code == 0 || response.data.code == '10006'){
           if(response.data.hasOwnProperty('errMsg')){
             reject(response.data);
           }else{
             resolve(response.data);
           }
        }else{
          if(response.data.hasOwnProperty('errMsg')){
            detailCode(response.data);
            reject();
          }
        }
      },err=>{
        Vue.prototype.$notify.error({
          title: '错误',
          message: err
        });
      })
      .catch(error=>{
        // store.commit('UPDATE_LOADING',false);
        Vue.prototype.$notify.error({
          title: 'error',
          message: error
        });
      })
  })
}
//封装post
export function pAJAX(url,params,config) {
  return new Promise((resolve,reject)=>{
    let data = params;
    let showNotify = true;
    //序列化数据
    if(!config){
      data = new FormData();
      if(typeof params === 'object'){
        for( let key in params){
          if(params.hasOwnProperty(key) && params[key] !== undefined){
            data.append(key,params[key]);
            config = {
              headers:{'Content-Type':'multipart/form-data'}
            };
          }
        }
      }
    }else{
      data = params;
    }
    axios.post(url,data,config)
      .then(response=>{
        // console.log(data)
        if(response.data.code == 0){
          if(response.data.hasOwnProperty('errMsg')){
            reject(response.data);
          }else{
            resolve(response.data);
            if(response.data.msg && showNotify){
              Vue.prototype.$notify({
                title: '成功',
                message: response.data.msg,
                type: 'success'
              });
            }
          }
        }else{
          if(response.data.hasOwnProperty('errMsg') && showNotify){
            detailCode(response.data)
            reject(response.data);
            // Vue.prototype.$alert(response.data.errMsg, '密码不正确', {
            //   confirmButtonText: '确定',
            // });
          }
        }
      },err=>{
        Vue.prototype.$notify.error({
          title: '错误',
          message: err
        });
      })
      .catch(error=>{
        // console.log(error);
        Vue.prototype.$notify.error({
          title: '错误',
          message: error
        });
      })
  })
}
export function dAJAX(url,params) {
  return new Promise((resolve)=>{
    axios.delete(url,params)
      .then(response=>{
        if(response.data.code == 0){
          if(response.data.msg){
            // Vue.prototype.$notify({
            //   title: '成功',
            //   message: response.data.msg,
            //   type: 'success'
            // });
            // Toast(response.data.msg);
          }else if(response.data.errMsg){
            Vue.prototype.$notify({
              title: '警告',
              message: response.data.errMsg,
              type: 'warning'
            });
            // Toast(response.data.errMsg);
          }
          resolve(response.data);
        }else{
          if(response.data.errMsg){
            Vue.prototype.$notify({
              title: '警告',
              message: response.data.errMsg,
              type: 'warning'
            });
            // Toast(response.data.errMsg);
          }
          detailCode(response.data)
        }
      },err=>{
        Vue.prototype.$notify.error({
          title: '错误',
          message: err
        });
        // Toast(err);
      })
      .catch(error=>{
        Vue.prototype.$notify.error({
          title: '错误',
          message: error
        });
        // Toast(error);
      })
  })
}
function detailCode(obj) {
  if(obj.code == 99999){
    axios.post('/webAuth/refreshToken','refreshToken='+window.btoa(unescape(encodeURIComponent(window.sessionStorage['refreshToken']))))
      .then(function (obj) {
        if(obj.data.code == '0'){
          window.sessionStorage['token'] = obj.data.access_token;
          var number = Date.parse(new Date());
          var url = window.location.href;
          if(/\?/.test(url)){
            url = url.substring(0,url.indexOf('?'));
          }
          window.location.reload(true);
        }
        else if(obj.data.code == '90001'){
          let url = window.location.href;
          let index = url.indexOf('#');
          return;
          // window.location.href = DOCAUTHORIZELINK+'?location_url=' + escape(url.substring(index+2,));
        }
      })
  }
}
//接口的封装
export  default{
//  人机验证获取验证值
getCaptcha(){
  return pAJAX('/webAuth/getCaptcha');
},
//  获取医生基本信息
  gainDocInfo (){
    return gAJAX('/doctor/info');
  },
  // http://testwx.hiwein.com/docv1/authorizeauthorize?location_url=certificate/addInfo
  //初始化
  initInfo(){
    // gAJAX('/doctor/initInfo').then(res => { console.log(res) })
    return gAJAX('/doctor/initInfo');
  },
  /********************************************************************************************
   *                                  通讯录相关
   * *****************************************************************************************/
  gainAllPat(){
    return gAJAX('/contactsManage/allPatients');
  },
  deletePatient(id1,id2){
    return dAJAX(`/contactsManage/deletePatient/${id1}/${id2}`);
  },
  editGroup(id){
    let gId = id ? `?group_id=${id}` : '';
    return gAJAX(`/contactsManage/groupQuery${gId}`);
  },
  deleteGroup(id){
    return dAJAX(`/contactsManage/deleteGroup/${id}`);
  },
  saveGroup(formData){
    let config = {
      headers:{'Content-Type':'multipart/form-data'}
    };
    return pAJAX('/contactsManage/saveGroup',formData,config);
  },

  //获取通讯录联系人
  // gainAllPat(){
  //   return gAJAX('/contacts/groups/patients');
  // },
  addGroup(params){
    return pAJAX(`/contacts/groups`,params);
  },
  movePat(params){
    return pAJAX(`/contacts/groups/${params.groId}/patients`,{patients_accounts : params.patId});
  },
//  获取所有分组
  gainAllGro(){
    return gAJAX('/contacts/groups');
  },
  //删除会员
  deletePat(params){
    return dAJAX(`/contacts/patients/${params}`);
  },
//  是否开启自动回复功能
  reviewSwitch(params){
    return pAJAX('/set/reviewSwitch',params);
  },
//  获取执业地信息
  gainDocHospital(params){
    return gAJAX('/doctor/hospitals'+ ( params ?　'/' + params: ''))
  },
//  删除执业地点
  deleteHospital(params){
    return dAJAX('/doctor/hospital/'+params)
  },
  addDocHospital(params,id){
    return pAJAX('/doctor/hospital  '+params)
  },
  /*******************************************服务开关*********************************************************/
//  服务开关
  gChatSwitch(){
    return gAJAX('/set/chatSwitch');
  },
  sChatSwitch(params){
    return pAJAX('/set/chatSetting',params);
  },
  gFamilySwitch(){
    return gAJAX('set/familySwitch');
  },
  sFamilySwitch(params){
    return pAJAX('/set/familySetting',params);
  },
  gFreeSetting(){
    return gAJAX('/set/freeSwitch');
  },
  sFreeSetting(params){
    return pAJAX(`/set/freeSetting`,params);
  },
  psFreeSetting(id,params){
    return pAJAX(`/set/freeSetForPatient/${id}`,params);
  },
  /*******************************************预约状态*********************************************************/
//  预约状态
  appointStatus(){
    return gAJAX('/set/appointSwitch');
  },
  appointSwitchSet(params){
    return pAJAX('/set/appointSetting',{switch : params});
  },
  gainAppointSet(params){
    let id = params ? `/getOne/${params}` : '/get';
    return gAJAX(`/appoint${id}`);
  },
  appointTimeSet(params){
    delete params['hospitalText'];
    if(params.id == 'null'){delete params['id']};
    return pAJAX('/appoint/set',params);
  },
  gainProvince(){
    return gAJAX('/hospitals/provinces');
  },
  gainAreas(params){
    return gAJAX(`/hospitals/${params}/areas`)
  },
  gainAHospital(d1,d2){
    return gAJAX(`/hospitals/${d1}/${d2}/all`)
  },
  searchHospital(params){
    return pAJAX('/hospitals',{keyword : params});
  },
  addDocHospital(params){
    let id = params.id ? `/${params.id}` : '';
    if(!params.provinces_area_id || !params.department || !params.technical){
    }else{
      return pAJAX(`/doctor/hospital${id}`,params);
    }
  },
  gainOrderDesc(id){
    return gAJAX(`/appoint/desc/${id}`);
  },
  appointSetList(){
    return gAJAX('/appoint/list')
  },


  /*******************************************预约相关*********************************************************/
//  预约相关
  appointList(params){
    return gAJAX(`/appoint/status/${params}`);
  },
  appointReview(params){
    return pAJAX('/appoint/review',params);
  },
  appointCancle(params){
    return pAJAX(`/appoint/cancel/${params.id}`,{reason : params.reason});
  },
  OrderCompleteSymbol(params){
    return pAJAX('/appoint/noArrive',params);
  },
  addOrderDesc(params){
    return pAJAX('/appoint/addDesc',params);
  },
  appointDetailInfo(params){
    return gAJAX(`/appoint/info/${params}`);
  },
  appointLog(params){
    return gAJAX(`/appoint/log/${params}`);
  },
  oAppointSet(params){
    return pAJAX('/appoint/setAppointTemporary',params);
  },
  oAppointStop(params){
    return pAJAX('/appoint/setAppointClosure',params);
  },
  appointStopList(params){
    return pAJAX('/appoint/appointClosures',params);
  },
  appointStopCancle(id){
    return pAJAX(`/appoint/cancelAppointClosure/${id}`);
  },
  appointTemporaries(params){
    return pAJAX('/appoint/appointTemporaries',params);
  },
  appointTemporaryDetail(id){
    return gAJAX(`/appoint/appointTemporaryDetail/${id}`);
  },
  appointeRecord(params){
    return pAJAX('/appoint/appointRecords',params);
  },
  /*******************************************会员信息*********************************************************/
  //会员信息
  patInfo(params){
    return gAJAX(`/patients/${params}/info`);
  },
  patInquiry(params){
    return gAJAX(`/patients/${params}/inquiry`);
  },
  patNotes(params){
    return gAJAX(`/patients/${params}/inquiry/notes`);
  },
  addPatNote(params){
    return pAJAX(`/patients/${params.id}/inquiry/notes`,{note: params.note});
  },
  delPatNote(params){
    return dAJAX(`/patients/${params.patId}/inquiry/notes/${params.noteId}`);
  },
  changeRemark(id,params){
    return pAJAX(`/patients/${id}/remark`,{remark : params});
  },
  evaluation(params){
     return pAJAX(`/patients/evaluation/${params.id}`,{type : params.type , page : params.page});
  },
  /*******************************************聊天相关*********************************************************/
//  聊天相关
  chatToken(params){
    return gAJAX('/chat/token');
  },
  hxPatInfo(params){
    return gAJAX(`/patients/hxAccountInfo/${params}`);
  },
  inviteSubscribe(id){
    return pAJAX(`/patients/inviteSubscribe/${id}`);
  },
  addOldRecord(id,params){
    return gAJAX(`/chat/messages/${id}/?page=${params.page}&timestamp=${params.timestamp}`);
  },
  newChatRecord(id,params){
    return gAJAX(`/chat/history/${id}/?page=${params.page}`);
  },
  getRelation(params){
    return pAJAX(`/chat/getRelation/${params.id}`,{msg :params.msg});
  },
  chatImage(params){
    let config = {
      headers:{'Content-Type':'multipart/form-data'}
    };
    return pAJAX('/chat/images',params,config);
  },
  sendVoice(params){
    return pAJAX(`/chat/media/${params}`);
  },
  gainReply(){
    return gAJAX('/chat/commonReply/get');
  },
  editReply(params){
    return pAJAX('/chat/commonReply/edit',params);
  },
  addReply(params){
    return pAJAX('/chat/commonReply/add',params);
  },
  deleteReply(params){
    return pAJAX('/chat/commonReply/delete',{id : params});
  },
  chatService(params){
    return pAJAX('/doctor/switch/chat',params);
  },
  serviceHistory(id,params){
    return pAJAX(`/order/patient/${id}`,params);
  },
  replayed(id){
    return pAJAX(`/chat/replayed/${id}`);
  },
  /*******************************************wx签名*********************************************************/
//  wx签名
  wxjsapi(){
    return gAJAX('/api/js');
  },
  /*******************************************登录注册相关*********************************************************/
//  登录注册相关
  login(params){
    return pAJAX('/webAuth/login',params);
  },
  //验证码登录
  loginForSmsCode(params){
     return pAJAX('/webAuth/loginForSmsCode',params);
  },
  sendSmsCode(params){
    return pAJAX('/webAuth/sendSmsCode',params);
  },
  //注册发送验证码
  sendSmsCodeForRegister(params){
    return pAJAX('/webAuth/sendSmsCodeForRegister',params);
  },
  register(params){
    return pAJAX('/webAuth/register',params);
  },
  getNewsSwitch(){
    return gAJAX('/getSwitch');
  },
  setNewsReportTime(params){
    return pAJAX('/set/messageSwitch',params);
  },
  resetIphone(params){
    return pAJAX('/login/resetPhone',params);
  },
  revisePassword(params){
    return pAJAX('/login/restpass',params);
  },
  resetPass(params){
    return pAJAX('/webAuth/resetPass',params);
  },
  getWXinfo(){
    return gAJAX('/webAuth/getWxInfo');
  },
  /*******************************************医生信息相关*********************************************************/
//  医生信息相关
  updateFace(params){
    let config = {
      headers:{'Content-Type':'multipart/form-data'}
    };
    return pAJAX('/doctor/face',params,config);
  },
  updateDocInfo(params){
    console.log();
    return pAJAX('/doctor/info',params);
  },
  uploadCertify(params){
    let config = {
      headers:{'Content-Type':'multipart/form-data'}
    };
    return pAJAX('/doctor/certify',params,config);
  },
  undo(){
    return gAJAX('/doctor/todoNum');
  },
  /*******************************************会员报到相关*********************************************************/
//会员报到 相关
  reportList(){
    return gAJAX('/contacts/checkInList')
  },
//同意会员报到
  reportPass(params){
    return pAJAX(`/contacts/patients/${params}/reviewPass`)
  },
//  获取会员报到信息
  gainReportPat(){
    return gAJAX('/contacts/patients');
  },
//  详细月份报到情况
  monthReport(params){
    return gAJAX(`/contacts/checkInStat?month=${params}`);
  },
  /*******************************************钱包相关*********************************************************/
  bankList(){
    return gAJAX('/wallet/banks');
  },
  addBankCard(params){
    return pAJAX('/wallet/addBankCard',params);
  },
  transfer(params){
    return pAJAX('/wallet/transfer',params);
  },
  gBankCard(){
    return gAJAX('/wallet/bankCards');
  },
  dBankCard(id){
    return pAJAX(`/wallet/unbindBankCard`,{bank_card_id : id})
  },
//  绑卡验证码
  bankCardCode(id){
    return pAJAX('/wallet/bandCardVerifyCode',id);
  },
//  微信账户验证码
  weixinCode(id){
    return pAJAX('/wallet/sendWechatTransferCode',id)
  },
  addWeixin(params){
    return pAJAX('/wallet/addWechatTransfer',params)
  },
//  提现验证码
  amountCode(id){
    return pAJAX('/wallet/transferVerifyCode',id);
  },
  transferRecord(){
    return gAJAX('/wallet/transferRecords');
  },
  transferDetail(id){
    return gAJAX(`/wallet/transferDetail/${id}`);
  },
  /*******************************************我的钱包*********************************************************/
  //查看钱包余额
  checkMoney(){
    return gAJAX('/wallet/amount');
  },
  incomeDeatil(params){
    return pAJAX('/wallet/income',params);
  },
  walletDetail(params){
    return pAJAX('/wallet/statement',params);
  },
  /*******************************************订单相关*********************************************************/
  gIndentList(params){
    return pAJAX('/order/myOrders',params);
  },
  gIndentDetail(params){
    return gAJAX(`/order/detail/${params}`);
  },
  myInquiries(params){
    return pAJAX('/order/myInquiries',params);
  },
  replyInquiries(){
    return gAJAX('/order/replyInquiries');
  },
  /*******************************************版本引导*********************************************************/
  versionLead(params){
    return pAJAX('/doctor/updateVersion',{version : params});
  },
  /*******************************************群发*********************************************************/
  gGroupNotify(page){
    return pAJAX('/tool/getPatientsNotify',{page : page});
  },
  dGroupNotify(page){
    return dAJAX(`/tool/patientsNotify/${page}`);
  },
  pGroupNotify(params){
    return pAJAX('/tool/sendPatientsNotify',params);
  },
  /*******************************************我的科普*********************************************************/
  addArticles(params){
    return pAJAX('/articles/addArticles',params);
  },
  myArticles(params){
    return pAJAX('/articles/myArticles',{page : params});
  },
  articles(params){
    return pAJAX('/articles/articles',params);
  },
  deleArticles(params){
    return pAJAX('/articles/disCollectArticles',{articles_id : params});
  },
  articleDetail(params){
    return gAJAX(`/articles/detailArticles/${params}`);
  },
  collectArticles(params){
    return pAJAX('/articles/collectArticles',{articles_id : params});
  },
  searchArticles(params){
    return pAJAX('/articles/articlesSearch',params);
  },
  articleUrl(url){
    return gAJAX(`/articles/url?url=${url}`);
  },
  getFile(){
     return gAJAX('/articles/getFile');
  },
  addFile(file){
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      };
     return pAJAX('/articles/addFile',file,config);
  },
  downloadFile(doc_account,article_id){
    return gAJAX(`/articles/downloadFile/${doc_account}/${article_id}`);
  },
  cancelFile(article_id){
    return dAJAX(`/articles/cancelFile/${article_id}`);
  },
  getTmp(){
    return gAJAX('/articles/getTmp');
  },
  saveTmp(params){
    return pAJAX('/articles/saveTmp',params);
  },
  addArticlesByContent(params){
    return pAJAX('/articles/addArticlesByContent',params);
  },
  /*******************************************儿童信息采集卡*********************************************************/
  gainAllCaseCardQues(){
    return gAJAX('/paper/getQuestionsFromPaper/1');
  },
  gainAllCaseCardAnswer(id){
    return gAJAX(`/paper/getPaperAnswer/${id}/1`);
  },
  savePaperAnswer(acc,id,params){
    return pAJAX(`/paper/savePaperAnswer/${acc}/${id}`,params, '');
  },
  getDrugName() {
    return gAJAX(`/paper/drugNames`)
  },
  getDose() {
    return gAJAX(`/paper/drugDose`)
  },
  getDrugUnit() {
    return gAJAX(`/paper/drugUnit`)
  },
  getWay() {
    return gAJAX(`/paper/drugWay`)
  },
  getUpdateTime(pat_account) {
    return gAJAX(`/paper/getAnswersFromPaper/${pat_account}/1`)
  },
  /***********************************************我的研究********************************************************/
  getReasearchNos() {
    return gAJAX(`/research/getResearchNos`)
  },
  getResearchAnswer (paper_answer_id) {
    return gAJAX(`/research/getResearchAnswer/${paper_answer_id}`);
  },
  saveResearchAnswer (data) {
    return pAJAX(`/research/saveResearch`, data);
  },
  getResearches (param) {
    let params = '';
    if (param) {
      Object.keys(param).forEach(i => {
        params += `${i}=${param[i]}&`;
      })
    }
    params = params.substring(0, params.length - 1)
     return gAJAX(`/research/researches?${params}`);
   },
   delete_research (params) {
     return dAJAX(`/research/deleteResearch/${params}`);
   }
}



// WEBPACK FOOTER //
// ./src/fetch/api.js